import React from "react";
import QuizView from "../components/QuizView";

function QuizPage() {
    return (
        <div className="page">
            <h1>Your Quiz</h1>
            <QuizView />
        </div>
    );
}

export default QuizPage;
